export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сума"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Результат"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Транзакція"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Оновити статус"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Корисні посилання"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Блокчейн:"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["В процесі"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успішно"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Невдало"])}
}